import React from 'react'
import { Skeleton as ChakraSkeleton, SkeletonProps as ChakraSkeletonProps } from '@chakra-ui/core'

export interface SkeletonProps extends ChakraSkeletonProps {}

export const Skeleton = ({
  colorStart = '#F8F8F8',
  colorEnd = '#DDD',
  ...restProps
}: SkeletonProps) => {
  return <ChakraSkeleton colorStart={colorStart} colorEnd={colorEnd} {...restProps} />
}

export default Skeleton
